import type { Container, Text } from 'pixi.js';
import { onLayoutPopulated } from '../populate';

// eslint-disable-next-line @typescript-eslint/naming-convention
type TextWithData = Text & { data: { replaceText_SPL?: Record<string, string | number>}};

export function replaceTextSPL(): void {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  onLayoutPopulated.connect((layout: { root: Container; replaceText_SPL?: TextWithData[] | TextWithData }) => {
    if (!layout.replaceText_SPL) return;

    const texts = Array.isArray(layout.replaceText_SPL) ? layout.replaceText_SPL : [layout.replaceText_SPL];

    texts.forEach((text) => {
      if (!text.data.replaceText_SPL) return;

      let tempText = text.text;

      Object.entries(text.data.replaceText_SPL).forEach(([key, value]) => {
        tempText = tempText.replaceAll(key, `${value}`);
      });

      text.text = tempText;
    });
  });
}
